import { render, staticRenderFns } from "./GSbySupervisor.vue?vue&type=template&id=fc85e55e&scoped=true&"
import script from "./GSbySupervisor.vue?vue&type=script&lang=js&"
export * from "./GSbySupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc85e55e",
  null
  
)

export default component.exports